import { PERIODICITY } from 'shared/enums';

export const remunerationFieldsToRemove = (
  periodicityType: PERIODICITY,
  otherFields = [] as string[],
): string[] => {
  const commumFields = [
    'id',
    'history',
    '_id',
    'createdAt',
    'updatedAt',
    'isActive',
  ];

  if (periodicityType !== PERIODICITY.monthSpecification) {
    commumFields.push('periodicityMonthSpecification');
  }

  return [...commumFields, ...otherFields];
};
